let SESSION_ID;

export function getSessionId() {
  if (!SESSION_ID) {
    let id = sessionStorage['SESSION_ID'] || new Date().getTime().toString(36);
    SESSION_ID = sessionStorage['SESSION_ID'] = id;
  }

  return SESSION_ID;
}
